import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withAppLogo } from '../../decorators/withAppLogo';
import Image from '../Image/Image';
import classNames from 'classnames';
import { omit } from 'lodash';
import { MODULE_CODES_LIST } from '../../constants/moduleCodes';

@withAppLogo
export class AppLogo extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    logoUrl: PropTypes.string,
    moduleCode: PropTypes.oneOf(MODULE_CODES_LIST)
  };

  render() {
    const { className, logoUrl, moduleCode } = this.props;

    return (
      <Image
        className={classNames('esk-app-logo', `esk-app-logo__${moduleCode}`, className)}
        src={logoUrl}
        alt="App Logo"
        {...omit(this.props, 'className', 'logoUrl', 'moduleCode')}
      />
    );
  }

}
